<template>
<div id="secure">

    <section class="main-content columns is-fullheight">
        <SideMenu />
        <div class="container column is-9">
            <div class="section">
                <a class="button is-info is-outlined" v-on:click="goTutorial()" style="margin-top:-10px; margin-bottom: 5px;">
                    <span class="icon navbar-icon"><i class="fa fa-youtube-play"></i></span> Tutorial
                </a>
                <a class="button is-info is-outlined" v-on:click="getHelp()" style="margin-top:-10px; margin-bottom: 5px;">
                    <span class="icon navbar-icon"><i class="fa fa-question-circle"></i></span> Help
                </a>
                <a class="button is-info" href="https://www.studentqr.com/download" target="_blank" style="margin-top:-10px; margin-bottom: 5px;">
                    <span class="icon navbar-icon"><i class="fa fa-cloud-download"></i></span> Download App
                </a>
                <a class="button is-primary" v-on:click="goNewAdmin()" style="margin-top:-10px; margin-bottom: 5px;">
                    <span class="icon navbar-icon"><i class="fa fa-star"></i></span> Switch to New Admin
                </a>
                <div class="card is-hidden1">
                    <div class="card-header">
                        <p class="card-header-title">Today's Activity </p><p class="header-date"> {{ dateDisplay }}</p>
                    </div>
                    <div class="card-content">
                        <div class="columns">
                            <div class="column is-full">
                                <div class="card">
                                    <loading :active.sync="isLoading1" 
                                        :can-cancel="false" 
                                        :is-full-page="false">
                                    </loading>
                                    <header class="card-header">
                                        <p class="card-header-title">
                                            <b-select id="duration" name="duration" v-model="duration" class="header-input" style="margin-left: 10px;"  @input="getPositivePointsByDuration()">
                                                <option selected value="daily">Daily</option>
                                                <option selected value="monthly">Monthly</option>
                                                <option selected value="yearly">Yearly</option>
                                            </b-select>
                                            <datepicker @closed="getPositivePointsByDuration()"  v-model="durationDaily" wrapper-class="datepicker" placeholder="Select Date" :value="selectedDate" :class="$style.datepicker" calendar-button=true calendar-button-icon="fa fa-calendar" v-show="duration=='daily'"></datepicker>
                                            <b-select id="durationMonthly" name="durationMonthly" v-model="durationMonthly" class="header-input" style="margin-left: 10px;"  @input="getPositivePointsByDuration()" v-show="duration=='monthly'">
                                                <option selected value="1">January</option>
                                                <option selected value="2">February</option>
                                                <option selected value="3">March</option>
                                                <option selected value="4">April</option>
                                                <option selected value="5">May</option>
                                                <option selected value="6">June</option>
                                                <option selected value="7">July</option>
                                                <option selected value="8">August</option>
                                                <option selected value="9">September</option>
                                                <option selected value="10">October</option>
                                                <option selected value="11">November</option>
                                                <option selected value="12">December</option>
                                            </b-select>
                                            <b-select id="durationYearly" name="durationYearly" v-model="durationYearly" class="header-input" style="margin-left: 10px;"  @input="getPositivePointsByDuration()" v-show="duration=='yearly'">
                                                <option selected value="2019">2019</option>
                                                <option selected value="2020">2020</option>
                                            </b-select>
                                        </p>
                                        <a class="button is-info is-outlined header-button" v-on:click="goClassDashboard()">View by class</a>
                                    </header>
                                    <div class="card-content">
                                        <div class="content">
                                            <latest-points-daily 
                                            :positivePointsDailyID="positivePointsDailyID"
                                            :positivePointsDailyLabel="positivePointsDailyLabel" :positivePointsDailyColor="positivePointsDailyColor" :positivePointsDailyData="positivePointsDailyData" v-if="isPositivePointsDailyDataAvailable" :width="800"
                                            :key="dailyChartKey" v-show="duration=='daily'"></latest-points-daily>
                                            <latest-points-overall 
                                            :positivePointsOverallID="positivePointsOverallID" 
                                            :positivePointsOverallLabel="positivePointsOverallLabel" :positivePointsOverallColor="positivePointsOverallColor" :positivePointsOverallData="positivePointsOverallData" :positivePointsOverallYear="durationYearly" v-if="isPositivePointsOverallDataAvailable" :width="800"
                                            :key="overallChartKey" v-show="monthlyOrYearly(duration)"></latest-points-overall>
                                            <span v-if="!isPositivePointsOverallDataAvailable" class="inline-error-message">{{ durationYearlyErrorMessage }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="columns">
                            <div class="column is-full">
                                <div class="card">
                                    <loading :active.sync="isLoading2" 
                                        :can-cancel="false" 
                                        :is-full-page="false">
                                    </loading>
                                    <header class="card-header">
                                        <p class="card-header-title">Overall Points for 
                                            <b-select id="durationYearly" name="durationYearly" v-model="durationYearly" class="header-input" style="margin-left: 10px;"  @input="getPositivePointsOverall()">
                                                    <option selected value="2020">2020</option>
                                                    <option selected value="2019">2019</option>
                                            </b-select>
                                        </p>
                                        <a class="button is-info is-outlined header-button" v-on:click="goClassDashboard()">View by class</a>
                                    </header>
                                    <div class="card-content">
                                        <div class="content">
                                            <latest-points-overall 
                                            :positivePointsOverallID="positivePointsOverallID" 
                                            :positivePointsOverallLabel="positivePointsOverallLabel" :positivePointsOverallColor="positivePointsOverallColor" :positivePointsOverallData="positivePointsOverallData" :positivePointsOverallYear="durationYearly" v-if="isPositivePointsOverallDataAvailable" :width="800"
                                            :key="overallChartKey"></latest-points-overall>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> -->
                        <div class="columns">
                            <!-- <div class="column one-half">
                                <div class="card">
                                    <loading :active.sync="isLoading3" 
                                        :can-cancel="false" 
                                        :is-full-page="false">
                                    </loading>
                                    <header class="card-header">
                                        <p class="card-header-title">
                                        Today's Staff's Attendance ({{ staffCheckedInCount }}/{{ staffCount}})
                                        </p>
                                        <a class="button is-info is-outlined header-button" v-on:click="goStaffAttendance()">View</a>
                                    </header>
                                    <div class="card-content attendance-pie">
                                        <staff-attendance-daily :height="200" :staffCheckedInCount="staffCheckedInCount" :staffAbsentCount="staffAbsentCount" v-if="isStaffAttendanceDataAvailable"></staff-attendance-daily>
                                    </div>
                                </div>
                            </div> -->
                            <div class="column one-half">
                                <div class="card">
                                    <loading :active.sync="isLoading4" 
                                        :can-cancel="false" 
                                        :is-full-page="false">
                                    </loading>
                                    <header class="card-header">
                                        <p class="card-header-title">
                                        Today's Students' Attendance ({{ studentAttendanceCount }}/{{ studentCount}})
                                        </p>
                                        <a class="button is-info is-outlined header-button" v-on:click="goClassDashboard()">View</a>
                                    </header>
                                    <div class="card-content attendance-pie">
                                        <student-attendance-daily :height="200" :studentAttendanceCount="studentAttendanceCount" :studentAbsentCount="studentAbsentCount" v-if="isStudentAttendanceDataAvailable"></student-attendance-daily>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <br />

                <div class="card">
                    <div class="card-header">
                        <p class="card-header-title">Latest Positive Behaviors</p>
                        
                        <div class="header-button">
                            <a class="button is-info" v-on:click="goSchoolPositiveDetails()">View Positive History Details</a>
                        </div>
                    </div>
                    <div class="card-content">
                        <div class="content">
                            <div class="columns is-multiline">

                                <div class="column is-half right-border">
                                    <div class="columns">
                                        <div class="column">Name</div>
                                        <div class="column">Activity</div>
                                        <div class="column is-one-fifth">Points</div>
                                    </div>
                                </div>
                                <div class="column is-half">
                                    <div class="columns">
                                        <div class="column">Name</div>
                                        <div class="column">Activity</div>
                                        <div class="column is-one-fifth">Points</div>
                                    </div>
                                </div>

                                <div class="column is-half top-border" v-for="(activity,index) in latestActivities" :key="activity._id" v-bind:class="isShowRightBorder(index)" >
                                    <div class="columns">
                                        <div class="column">{{ activity.studentID.firstName }} {{ activity.studentID.lastName }}</div>
                                        <div class="column">{{ activity.positiveID.name }}</div>
                                        <div class="column is-one-fifth text-center">{{ roundTo2DecimalPlaces(activity.points) }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <br />

                <!-- <div class="card is-hidden1">
                    <div class="card-header">
                        <p class="card-header-title">Header</p>
                    </div>
                    <div class="card-content">
                        <div class="content">Content</div>
                    </div>
                </div>
                <br /> -->

            </div>
        </div>

    </section>    
</div>
</template>

<script>
import SideMenu from './SideMenu'
import axios from 'axios'
//import Chart from 'vue-bulma-chartjs'
import "./public/style.scss";
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import Datepicker from 'vuejs-datepicker';

import LatestPointsDaily from './Charts/LatestPointsDaily'
import LatestPointsOverall from './Charts/LatestPointsOverall'
import StaffAttendanceDaily from './Charts/StaffAttendanceDaily'
import StudentAttendanceDaily from './Charts/StudentAttendanceDaily'

export default {
    name: "dashboard",
    components: {
        SideMenu,
        LatestPointsDaily,
        LatestPointsOverall,
        StaffAttendanceDaily,
        StudentAttendanceDaily,
        Loading,
        Datepicker
    },
    data() {
        return {
            selectedDate: '',
            currentYear: 0,
            dateDisplay: '',
            staffCount: 0,
            dailyChartKey: '',
            monthlyChartKey: '',
            overallChartKey: '',
            duration: 'daily',    //daily, monthly, yearly
            durationDaily: '',
            durationMonthly: '',
            durationYearly: '',
            durationMonthlyErrorMessage: '',
            durationYearlyErrorMessage: '',
            
            isPositivePointsDailyDataAvailable: false,
            positivePointsDailyID: [],
            positivePointsDailyLabel: [],
            positivePointsDailyColor: [],
            positivePointsDailyData: [],

            isPositivePointsOverallDataAvailable: false,
            positivePointsOverallID: [],
            positivePointsOverallLabel: [],
            positivePointsOverallColor: [],
            positivePointsOverallData: [],
            
            isPositivePointsMonthlyDataAvailable: false,
            positivePointsMonthlyID: [],
            positivePointsMonthlyLabel: [],
            positivePointsMonthlyColor: [],
            positivePointsMonthlyData: [],

            isStaffAttendanceDataAvailable: false,
            staffCheckedInCount: 0,
            staffAbsentCount: 0,
            isStudentAttendanceDataAvailable: false,
            studentCount: 0,
            studentAttendanceCount: 0,
            studentAbsentCount:0,

            latestActivities: [],

            isLoading1: false,
            isLoading2: false,
            isLoading3: false,
            isLoading4: false,
            isLoading5: false,
            lastRefresh: '',
            schoolID: '',
            currentTS: ''
        };
    },
    beforeMount() {
        this.$emit("authenticated", true);
    },
    created() {
        console.log("272")
        console.log(process.env)
        this.schoolID = localStorage.getItem('schoolID');
        var currentDate = new Date();
        this.currentTS = new Date().getTime();
        //var todayDate = currentDate.getDate() + " " + currentDate.getMonth() + " " + currentDate.getFullYear() + " " + currentDate.getHours() + " " + currentDate.getMilliseconds();
        var currentDay = currentDate.getDate();
        if (currentDate.getDate() < 10){
            currentDay = "0" + currentDay;
        }
        this.currentYear = currentDate.getFullYear()
        this.durationYearly = this.currentYear
        var currentMonth = currentDate.getMonth() + 1;  //since month starts from 0

        this.durationDaily = new Date(currentDate.getFullYear(),currentDate.getMonth(),currentDate.getDate())
        this.durationMonthly = currentMonth

        if (currentMonth < 10){
            currentMonth = "0" + currentMonth;
        }
        this.selectedDate = this.currentYear + "" + currentMonth + "" + currentDay;
        console.log("selectedDate: " + this.selectedDate)

        var month = currentDate.getMonth();
        var dayOfWeek = currentDate.getDay();

        var dayOfWeekDisplay = "";
        switch (dayOfWeek){
            case 0:
                dayOfWeekDisplay = "Sunday";
                break;
            case 1:
                dayOfWeekDisplay = "Monday";
                break;
            case 2:
                dayOfWeekDisplay = "Tuesday";
                break;
            case 3:
                dayOfWeekDisplay = "Wednesday";
                break;
            case 4:
                dayOfWeekDisplay = "Thursday";
                break;
            case 5:
                dayOfWeekDisplay = "Friday";
                break;
            case 6:
                dayOfWeekDisplay = "Saturday";
                break;
            default:
                dayOfWeekDisplay = "Monday";
                break;
        }

        var monthDisplay = "";
        switch (month){
            case 0:
                monthDisplay = "January";
                break;
            case 1:
                monthDisplay = "February";
                break;
            case 2:
                monthDisplay = "March";
                break;
            case 3:
                monthDisplay = "April";
                break;
            case 4:
                monthDisplay = "May";
                break;
            case 5:
                monthDisplay = "June";
                break;
            case 6:
                monthDisplay = "July";
                break;
            case 7:
                monthDisplay = "August";
                break;
            case 8:
                monthDisplay = "September";
                break;
            case 9:
                monthDisplay = "October";
                break;
            case 10:
                monthDisplay = "November";
                break;
            case 11:
                monthDisplay = "December";
                break;
            default:
                monthDisplay = "January";
                break;
        }

        var dateDisplay = dayOfWeekDisplay + ", " + currentDate.getDate() + " " + monthDisplay + " " + currentDate.getFullYear();
        this.dateDisplay = dateDisplay;
        // this.getStaffAttendance()
        this.getPositivePointsDaily()
        // this.getPositivePointsOverall()
        this.getStudentAttendance()
        this.getLatestPositiveActivities()

        let userLogin = sessionStorage.getItem('userLogin');
    },
    mounted(){        
    },
    methods: {
        goTutorial(){
            window.open("https://www.studentqr.com/resources", '_blank');
        },
        getHelp(){
            window.open("https://helpstudentqr.wasap.my", '_blank');
        },
        monthlyOrYearly(duration){
            console.log("379 duration: " + duration)
            if ((duration == "yearly") || (duration == "monthly")){
                return true;
            }else{
                return false;
            }
        },
        getPositivePointsByDuration(){
            console.log("getPositivePointsByDuration duration: " + this.duration)
            console.log("durationDaily: " + this.durationDaily)
            console.log("durationMonthly: " + this.durationMonthly)
            console.log("durationYearly: " + this.durationYearly)

            if (this.duration == "daily"){
                var getDate = this.durationDaily.getDate();
                var getMonth = this.durationDaily.getMonth() + 1;
                if (getDate < 10){
                    getDate = "0" + getDate
                }
                if (getMonth < 10){
                    getMonth = "0" + getMonth
                }
                this.selectedDate = this.durationDaily.getFullYear() + "" + getMonth + "" + getDate;
                this.getPositivePointsDaily()
                
            }else if (this.duration == "monthly"){
                this.getPositivePointsMonthly()
            }else if (this.duration == "yearly"){
                this.getPositivePointsOverall()
            }
        },
        getPositivePointsDaily() {
            let self = this;
            self.positivePointsDailyID = []
            self.positivePointsDailyLabel = []
            self.positivePointsDailyColor = []
            self.positivePointsDailyData = []

            console.log("getPositivePointsDaily for selectedDate: " + self.selectedDate)

            if (localStorage.getItem(self.schoolID + '_dashboard_positive_points_daily_' + self.selectedDate)){
                if (localStorage.getItem(self.schoolID + '_dashboard_positive_points_daily_' + self.selectedDate + '_ts')){
                    var prevTS = localStorage.getItem(self.schoolID + '_dashboard_positive_points_daily_' + self.selectedDate + '_ts');
                    var checkTimeDifference = this.timeDifference(self.currentTS,prevTS);
                    //28 Aug 2019 - we set the checkTimeDifference below to be higher than hourToCache so the system will always get the latest data instead of the cached one. Later if there's an issue with traffic or server's capability, we will comment out the line below
                    checkTimeDifference = 4;
                    if (checkTimeDifference > this.$hourToCacheData){
                        console.log("getPositivePointsDaily dah lebih " + this.$hourToCacheData + " jam, reamik")
                        this.getPositivePointsDailyFromServer(self)
                    }else{
                        console.log("getPositivePointsDaily kurang sejam, amik dari cache")

                        var dataLength = localStorage.getItem(self.schoolID + '_dashboard_positive_points_daily_' + self.selectedDate + '_length');                        
                        for (var i = 0; i < dataLength; i++){
                            if (localStorage.getItem(self.schoolID + '_dashboard_positive_points_daily_' + self.selectedDate + '_positivePointsDailyID_' + i) !== null){
                                self.positivePointsDailyID.push(JSON.parse(localStorage.getItem(self.schoolID + '_dashboard_positive_points_daily_' + self.selectedDate + '_positivePointsDailyID_' + i)))
                            }
                            if (localStorage.getItem(self.schoolID + '_dashboard_positive_points_daily_' + self.selectedDate + '_positivePointsDailyLabel_' + i) !== null){
                                self.positivePointsDailyLabel.push(JSON.parse(localStorage.getItem(self.schoolID + '_dashboard_positive_points_daily_' + self.selectedDate + '_positivePointsDailyLabel_' + i)))
                            }
                            if (localStorage.getItem(self.schoolID + '_dashboard_positive_points_daily_' + self.selectedDate + '_positivePointsDailyColor_' + i) !== null){
                                self.positivePointsDailyColor.push(JSON.parse(localStorage.getItem(self.schoolID + '_dashboard_positive_points_daily_' + self.selectedDate + '_positivePointsDailyColor_' + i)))
                            }
                            if (localStorage.getItem(self.schoolID + '_dashboard_positive_points_daily_' + self.selectedDate + '_positivePointsDailyData_' + i) !== null){
                                self.positivePointsDailyData.push(JSON.parse(localStorage.getItem(self.schoolID + '_dashboard_positive_points_daily_' + self.selectedDate + '_positivePointsDailyData_' + i)))
                            }
                        }
                        self.lastRefresh = localStorage.getItem(self.schoolID + '_dashboard_positive_points_daily_' + self.selectedDate + '_last_refresh');

                        self.isPositivePointsDailyDataAvailable = true
                    }
                }else{
                    console.log("getPositivePointsDaily ts takde, jadi amik dari server")
                    this.getPositivePointsDailyFromServer(self)
                }
            }else{
                console.log("getPositivePointsDaily localStorage takde, jadi amik dari server")
                this.getPositivePointsDailyFromServer(self)
            }
        },
        getPositivePointsDailyFromServer(self){            
            console.log("427 self.selectedDate: " + self.selectedDate)
            self.isLoading1 = true;
            axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
            axios.defaults.responseType = 'json'
            axios.post(process.env.MY_URL + '/api/students/positive', {
                    params: {
                        email: localStorage.getItem('email'),
                        sessionID: localStorage.getItem('sessionID'),
                        show: 'today',
                        actionDate: self.selectedDate
                    }
                })
                .then(response => {
                    self.dailyChartKey = self.selectedDate  + new Date().getTime() //this will recreate the overall chart to display the chart for selected date

                    if (response.data.length > 0){
                        
                        var d = new Date();
                        self.lastRefresh = d.getDate() + " " + self.getMonthDisplay(d.getMonth()) + " " + d.getFullYear() + ", " + d.getHours() + ":" + d.getMinutes();
                        
                        localStorage.setItem(self.schoolID + '_dashboard_positive_points_daily_' + self.selectedDate,"OK")
                        localStorage.setItem(self.schoolID + '_dashboard_positive_points_daily_' + self.selectedDate + '_ts',Date.now())
                        localStorage.setItem(self.schoolID + '_dashboard_positive_points_daily_' + self.selectedDate + '_last_refresh',self.lastRefresh)
                        localStorage.setItem(self.schoolID + '_dashboard_positive_points_daily_' + self.selectedDate + "_length",response.data.length)
                    }

                    for (var i = 0; i < response.data.length; i++){
                        self.positivePointsDailyID.push(response.data[i]._id)
                        self.positivePointsDailyLabel.push(response.data[i].name)
                        self.positivePointsDailyColor.push(response.data[i].colour)
                        self.positivePointsDailyData.push(response.data[i].tempTotalPoints)
                        
                        localStorage.setItem(self.schoolID + '_dashboard_positive_points_daily_' + self.selectedDate + '_positivePointsDailyID_' + i,JSON.stringify(response.data[i]._id));
                        localStorage.setItem(self.schoolID + '_dashboard_positive_points_daily_' + self.selectedDate + '_positivePointsDailyLabel_' + i,JSON.stringify(response.data[i].name));
                        localStorage.setItem(self.schoolID + '_dashboard_positive_points_daily_' + self.selectedDate + '_positivePointsDailyColor_' + i,JSON.stringify(response.data[i].colour));
                        localStorage.setItem(self.schoolID + '_dashboard_positive_points_daily_' + self.selectedDate + '_positivePointsDailyData_' + i,JSON.stringify(response.data[i].tempTotalPoints));
                    }

                    self.isPositivePointsDailyDataAvailable = true
                    self.isLoading1 = false;
                })
                .catch(e => {
                    console.log(e)
                    self.isLoading1 = false;
                })
        },
        getPositivePointsOverall() {      
            let self = this;
            console.log('getPositivePointsOverall_' + self.durationYearly)      
            self.positivePointsOverallID = []
            self.positivePointsOverallLabel = []
            self.positivePointsOverallColor = []
            self.positivePointsOverallData = []

            if (localStorage.getItem(self.schoolID + '_dashboard_positive_points_overall_' + self.durationYearly)){
                if (localStorage.getItem(self.schoolID + '_dashboard_positive_points_overall_' + self.durationYearly + '_ts')){
                    var prevTS = localStorage.getItem(self.schoolID + '_dashboard_positive_points_overall_' + self.durationYearly + '_ts');
                    var checkTimeDifference = this.timeDifference(self.currentTS,prevTS);
                    if (checkTimeDifference > this.$hourToCacheData){
                        console.log("getPositivePointsOverall dah lebih sejam, reamik")
                        this.getPositivePointsOverallFromServer(self)
                    }else{
                        console.log("getPositivePointsOverall kurang sejam, amik dari cache")

                        var dataLength = localStorage.getItem(self.schoolID + '_dashboard_positive_points_overall_' + self.durationYearly +'_length');
                        console.log("imini 527 dataLength: " + dataLength)         
                        for (var i = 0; i < dataLength; i++){
                            if (localStorage.getItem(self.schoolID + '_dashboard_positive_points_overall_' + self.durationYearly +'_positivePointsOverallID_' + i) !== null){
                                self.positivePointsOverallID.push(JSON.parse(localStorage.getItem(self.schoolID + '_dashboard_positive_points_overall_' + self.durationYearly +'_positivePointsOverallID_' + i)))
                            }
                            if (localStorage.getItem(self.schoolID + '_dashboard_positive_points_overall_' + self.durationYearly +'_positivePointsOverallLabel_' + i) !== null){
                                self.positivePointsOverallLabel.push(JSON.parse(localStorage.getItem(self.schoolID + '_dashboard_positive_points_overall_' + self.durationYearly +'_positivePointsOverallLabel_' + i)))
                            }
                            if (localStorage.getItem(self.schoolID + '_dashboard_positive_points_overall_' + self.durationYearly +'_positivePointsOverallColor_' + i) !== null){
                                self.positivePointsOverallColor.push(JSON.parse(localStorage.getItem(self.schoolID + '_dashboard_positive_points_overall_' + self.durationYearly +'_positivePointsOverallColor_' + i)))
                            }
                            if (localStorage.getItem(self.schoolID + '_dashboard_positive_points_overall_' + self.durationYearly +'_positivePointsOverallData_' + i) !== null){
                                self.positivePointsOverallData.push(JSON.parse(localStorage.getItem(self.schoolID + '_dashboard_positive_points_overall_' + self.durationYearly +'_positivePointsOverallData_' + i)))
                            }
                        }

                        console.log("imini 543 self.positivePointsOverallData:")
                        console.log(self.positivePointsOverallData)

                        self.overallChartKey = self.durationYearly  //this will recreate the overall chart to display the selected year value
                        self.isPositivePointsOverallDataAvailable = true
                    }
                }else{
                    console.log("getPositivePointsOverall ts takde, jadi amik dari server")
                    this.getPositivePointsOverallFromServer(self)
                }
            }else{
                console.log("getPositivePointsOverall localStorage takde, jadi amik dari server")
                this.getPositivePointsOverallFromServer(self)
            }
        },
        getPositivePointsOverallFromServer(self){
            self.isLoading1 = true;
            axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
            axios.defaults.responseType = 'json'
            axios.post(process.env.MY_URL + '/api/students/positive', {
                    params: {
                        email: localStorage.getItem('email'),
                        sessionID: localStorage.getItem('sessionID'),
                        show: 'overall',
                        year: self.durationYearly
                    }
                })
                .then(response => {

                    if (response.data.success == false){

                        self.isPositivePointsOverallDataAvailable = false
                        self.durationYearlyErrorMessage = response.data.msg

                    }else{
                    
                        if (response.data.length > 0){                        
                            localStorage.setItem(self.schoolID + '_dashboard_positive_points_overall_' + self.durationYearly,"OK")
                            localStorage.setItem(self.schoolID + '_dashboard_positive_points_overall_' + self.durationYearly + '_ts',Date.now())
                            localStorage.setItem(self.schoolID + '_dashboard_positive_points_overall_' + self.durationYearly +'_length',response.data.length)
                        }
                        self.overallChartKey = self.durationYearly  //this will recreate the overall chart to display the selected year value


                        for (var i = 0; i < response.data.length; i++){
                            self.positivePointsOverallID.push(response.data[i]._id)
                            self.positivePointsOverallLabel.push(response.data[i].name)
                            self.positivePointsOverallColor.push(response.data[i].colour)
                            self.positivePointsOverallData.push(response.data[i].tempTotalPoints)
                            
                            localStorage.setItem(self.schoolID + '_dashboard_positive_points_overall_' + self.durationYearly +'_positivePointsOverallID_' + i,JSON.stringify(response.data[i]._id));
                            localStorage.setItem(self.schoolID + '_dashboard_positive_points_overall_' + self.durationYearly +'_positivePointsOverallLabel_' + i,JSON.stringify(response.data[i].name));
                            localStorage.setItem(self.schoolID + '_dashboard_positive_points_overall_' + self.durationYearly +'_positivePointsOverallColor_' + i,JSON.stringify(response.data[i].colour));
                            localStorage.setItem(self.schoolID + '_dashboard_positive_points_overall_' + self.durationYearly +'_positivePointsOverallData_' + i,JSON.stringify(response.data[i].tempTotalPoints));
                        }

                        self.isPositivePointsOverallDataAvailable = true

                    }
                    self.isLoading1 = false;
                })
                .catch(e => {
                    console.log(e)
                    self.isLoading1 = false;
                })
        },
        getPositivePointsMonthly() {
            console.log("getPositivePointsMonthly")            
            let self = this;
            self.positivePointsOverallID = []
            self.positivePointsOverallLabel = []
            self.positivePointsOverallColor = []
            self.positivePointsOverallData = []

            if (localStorage.getItem(self.schoolID + '_dashboard_positive_points_overall_' + self.durationYearly + "_" + self.durationMonthly)){
                if (localStorage.getItem(self.schoolID + '_dashboard_positive_points_overall_' + self.durationYearly + "_" + self.durationMonthly + '_ts')){
                    var prevTS = localStorage.getItem(self.schoolID + '_dashboard_positive_points_overall_' + self.durationYearly + "_" + self.durationMonthly + '_ts');
                    var checkTimeDifference = this.timeDifference(self.currentTS,prevTS);
                    // checkTimeDifference = 4;    //28 Aug 2019 - force get latest data
                    if (checkTimeDifference > this.$hourToCacheData){
                        console.log("getPositivePointsOverall dah lebih sejam, reamik")
                        this.getPositivePointsMonthlyFromServer(self)
                    }else{
                        console.log("getPositivePointsOverall kurang sejam, amik dari cache")

                        var dataLength = localStorage.getItem(self.schoolID + '_dashboard_positive_points_overall_'  + self.durationYearly + '_' + self.durationMonthly + '_length');                        
                        for (var i = 0; i < dataLength; i++){
                            if (localStorage.getItem(self.schoolID + '_dashboard_positive_points_overall_'  + self.durationYearly + '_' + self.durationMonthly + '_positivePointsOverallID_' + i) !== null){
                                self.positivePointsOverallID.push(JSON.parse(localStorage.getItem(self.schoolID + '_dashboard_positive_points_overall_'  + self.durationYearly + '_' + self.durationMonthly + '_positivePointsOverallID_' + i)))
                            }
                            if (localStorage.getItem(self.schoolID + '_dashboard_positive_points_overall_'  + self.durationYearly + '_' + self.durationMonthly + '_positivePointsOverallLabel_' + i) !== null){
                                self.positivePointsOverallLabel.push(JSON.parse(localStorage.getItem(self.schoolID + '_dashboard_positive_points_overall_'  + self.durationYearly + '_' + self.durationMonthly + '_positivePointsOverallLabel_' + i)))
                            }
                            if (localStorage.getItem(self.schoolID + '_dashboard_positive_points_overall_'  + self.durationYearly + '_' + self.durationMonthly + '_positivePointsOverallColor_' + i) !== null){
                                self.positivePointsOverallColor.push(JSON.parse(localStorage.getItem(self.schoolID + '_dashboard_positive_points_overall_'  + self.durationYearly + '_' + self.durationMonthly + '_positivePointsOverallColor_' + i)))
                            }
                            if (localStorage.getItem(self.schoolID + '_dashboard_positive_points_overall_'  + self.durationYearly + '_' + self.durationMonthly + '_positivePointsOverallData_' + i) !== null){
                                self.positivePointsOverallData.push(JSON.parse(localStorage.getItem(self.schoolID + '_dashboard_positive_points_overall_'  + self.durationYearly + '_' + self.durationMonthly + '_positivePointsOverallData_' + i)))
                            }
                        }

                        self.overallChartKey = self.durationMonthly  //this will recreate the overall chart to display the selected year value
                        self.isPositivePointsOverallDataAvailable = true
                    }
                }else{
                    console.log("getPositivePointsOverall ts takde, jadi amik dari server")
                    this.getPositivePointsMonthlyFromServer(self)
                }
            }else{
                console.log("getPositivePointsOverall localStorage takde, jadi amik dari server")
                this.getPositivePointsMonthlyFromServer(self)
            }

        },
        getPositivePointsMonthlyFromServer(self){
            console.log("entering getPositivePointsMonthlyFromServer")
            self.isLoading1 = true;
            axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
            axios.defaults.responseType = 'json'
            axios.post(process.env.MY_URL + '/api/students/positive', {
                    params: {
                        email: localStorage.getItem('email'),
                        sessionID: localStorage.getItem('sessionID'),
                        show: 'monthly',
                        year: self.currentYear,
                        month: self.durationMonthly
                    }
                })
                .then(response => {
                    
                    if (response.data.success == false){

                        self.isPositivePointsOverallDataAvailable = false
                        self.durationYearlyErrorMessage = response.data.msg

                    }else{

                        if (response.data.length > 0){                        
                            localStorage.setItem(self.schoolID + '_dashboard_positive_points_overall_' + self.currentYear + "_" + self.durationMonthly,"OK")
                            localStorage.setItem(self.schoolID + '_dashboard_positive_points_overall_' + self.currentYear + "_" + self.durationMonthly + '_ts',Date.now())
                            localStorage.setItem(self.schoolID + '_dashboard_positive_points_overall_'  + self.durationYearly + '_' + self.durationMonthly + '_length',response.data.length)
                        }
                        self.overallChartKey = self.durationMonthly  //this will recreate the overall chart to display the selected year value


                        for (var i = 0; i < response.data.length; i++){
                            self.positivePointsOverallID.push(response.data[i]._id)
                            self.positivePointsOverallLabel.push(response.data[i].name)
                            self.positivePointsOverallColor.push(response.data[i].colour)
                            self.positivePointsOverallData.push(response.data[i].tempTotalPoints)
                            
                            localStorage.setItem(self.schoolID + '_dashboard_positive_points_overall_'  + self.durationYearly + '_' + self.durationMonthly + '_positivePointsOverallID_' + i,JSON.stringify(response.data[i]._id));
                            localStorage.setItem(self.schoolID + '_dashboard_positive_points_overall_'  + self.durationYearly + '_' + self.durationMonthly + '_positivePointsOverallLabel_' + i,JSON.stringify(response.data[i].name));
                            localStorage.setItem(self.schoolID + '_dashboard_positive_points_overall_'  + self.durationYearly + '_' + self.durationMonthly + '_positivePointsOverallColor_' + i,JSON.stringify(response.data[i].colour));
                            localStorage.setItem(self.schoolID + '_dashboard_positive_points_overall_'  + self.durationYearly + '_' + self.durationMonthly + '_positivePointsOverallData_' + i,JSON.stringify(response.data[i].tempTotalPoints));
                        }

                        self.isPositivePointsOverallDataAvailable = true
                    }
                    self.isLoading1 = false;
                })
                .catch(e => {
                    console.log(e)
                    self.isLoading1 = false;
                })
        },
        getStaffAttendance() {
            console.log("getStaffAttendance")
            let self = this;
            self.staffCount = ''
            self.staffCheckedInCount = 0
            self.staffAbsentCount = 0
            self.isStaffAttendanceDataAvailable = ''

            if (localStorage.getItem(self.schoolID + '_dashboard_staff_attendance')){
                if (localStorage.getItem(self.schoolID + '_dashboard_staff_attendance_ts')){
                    var prevTS = localStorage.getItem(self.schoolID + '_dashboard_staff_attendance_ts');
                    var checkTimeDifference = this.timeDifference(self.currentTS,prevTS);
                    checkTimeDifference = 4;    //28 Aug 2019 - force get latest data
                    if (checkTimeDifference > this.$hourToCacheData){
                        console.log("getStaffAttendance dah lebih sejam, reamik")
                        this.getStaffAttendanceFromServer(self)
                    }else{
                        console.log("getStaffAttendance kurang sejam, amik dari cache je")

                        self.staffCount = localStorage.getItem(self.schoolID + '_dashboard_staff_attendance_staffCount');    
                        self.staffCheckedInCount = localStorage.getItem(self.schoolID + '_dashboard_staff_staffCheckedInCount');    
                        self.staffAbsentCount = localStorage.getItem(self.schoolID + '_dashboard_staff_staffAbsentCount');    

                        self.isStaffAttendanceDataAvailable = true
                    }
                }else{
                    console.log("getStaffAttendance ts takde, jadi amik dari server")
                    this.getStaffAttendanceFromServer(self)
                }
            }else{
                console.log("getStaffAttendance localStorage takde, jadi amik dari server")
                this.getStaffAttendanceFromServer(self)
            }
        },
        getStaffAttendanceFromServer(self){
            
            self.isLoading3 = true;
            axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
            axios.defaults.responseType = 'json'
            axios.post(process.env.MY_URL + '/api/teachers/attendance', {
                    params: {
                        email: localStorage.getItem('email'),
                        sessionID: localStorage.getItem('sessionID'),
                        show: 'today',
                        actionDate: self.selectedDate
                    }
                })
                .then(response => {
                    console.log("getStaffAttendance: ")
                    var dataList = response.data

                    self.staffCount = dataList.length

                    for (var i = 0; i < dataList.length; i++){
                        if (dataList[i].checkIn == true){
                            self.staffCheckedInCount = self.staffCheckedInCount + 1;
                        }
                    }
                    
                    self.staffAbsentCount = self.staffCount - self.staffCheckedInCount
                    self.isStaffAttendanceDataAvailable = true;
                    self.isLoading3 = false;

                    if (dataList.length > 0){                        
                        localStorage.setItem(self.schoolID + '_dashboard_staff_attendance',"OK")
                        localStorage.setItem(self.schoolID + '_dashboard_staff_attendance_ts',Date.now())
                        localStorage.setItem(self.schoolID + '_dashboard_staff_attendance_staffCount',dataList.length)
                        localStorage.setItem(self.schoolID + '_dashboard_staff_staffCheckedInCount',self.staffCheckedInCount)
                        localStorage.setItem(self.schoolID + '_dashboard_staff_staffAbsentCount',self.staffAbsentCount)
                    }

                    
                })
                .catch(e => {
                    console.log(e)
                    self.isLoading3 = false;
                })
        },
        getStudentAttendance() {
            console.log("getStudentAttendance") 
            let self = this;

            self.studentCount = ''
            self.studentAbsentCount = 0
            self.studentAttendanceCount = 0
            self.isStudentAttendanceDataAvailable = ''

            if (localStorage.getItem(self.schoolID + '_dashboard_student_attendance')){
                if (localStorage.getItem(self.schoolID + '_dashboard_student_attendance_ts')){
                    var prevTS = localStorage.getItem(self.schoolID + '_dashboard_student_attendance_ts');
                    var checkTimeDifference = this.timeDifference(self.currentTS,prevTS);
                    checkTimeDifference = 4;    //28 Aug 2019 - force get latest data
                    if (checkTimeDifference > this.$hourToCacheData){
                        console.log("getStudentAttendance dah lebih sejam, reamik")
                        this.getStudentAttendanceFromServer(self)
                    }else{
                        console.log("getStudentAttendance kurang sejam, amik dari cache je")

                        self.studentCount = localStorage.getItem(self.schoolID + '_dashboard_student_attendance_studentCount');    
                        self.studentAttendanceCount = localStorage.getItem(self.schoolID + '_dashboard_student_attendance_studentAttendanceCount');    
                        self.studentAbsentCount = localStorage.getItem(self.schoolID + '_dashboard_student_attendance_studentAbsentCount');    

                        self.isStudentAttendanceDataAvailable = true
                    }
                }else{
                    console.log("getStudentAttendance ts takde, jadi amik dari server")
                    this.getStudentAttendanceFromServer(self)
                }
            }else{
                console.log("getStudentAttendance localStorage takde, jadi amik dari server")
                this.getStudentAttendanceFromServer(self)
            }
        },
        getStudentAttendanceFromServer(self){
            self.isLoading4 = true;
            axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
            axios.defaults.responseType = 'json'
            axios.post(process.env.MY_URL + '/api/students/positive/attendance/overall', {
                    params: {
                        email: localStorage.getItem('email'),
                        sessionID: localStorage.getItem('sessionID'),
                        show: 'today',
                        actionDate: self.selectedDate
                    }
                })
                .then(response => {
                    console.log("getStudentAttendance: ")   

                    self.studentCount = response.data.studentCount
                    self.studentAttendanceCount = response.data.attendanceCount
                    self.studentAbsentCount = response.data.absentCount
                    self.isStudentAttendanceDataAvailable = true
                    self.isLoading4 = false;

                    console.log(response.data)

                    if (response.data.success){                        
                        localStorage.setItem(self.schoolID + '_dashboard_student_attendance',"OK")
                        localStorage.setItem(self.schoolID + '_dashboard_student_attendance_ts',Date.now())
                        localStorage.setItem(self.schoolID + '_dashboard_student_attendance_studentCount',response.data.studentCount)
                        localStorage.setItem(self.schoolID + '_dashboard_student_attendance_studentAttendanceCount',response.data.attendanceCount)
                        localStorage.setItem(self.schoolID + '_dashboard_student_attendance_studentAbsentCount',response.data.absentCount)
                    }
                })
                .catch(e => {
                    console.log(e)
                    self.isLoading4 = false;
                }) 
        },
        getLatestPositiveActivities() {
            //ni belum buat load dari cache sbb byk kerja; sbb data dia object dlm object
            this.isLoading5 = true;
            let self = this;

            console.log("getLatestPositiveActivities")
            axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
            axios.defaults.responseType = 'json'
            axios.post(process.env.MY_URL + '/api/students/positive/activities', {
                    params: {
                        email: localStorage.getItem('email'),
                        sessionID: localStorage.getItem('sessionID'),
                        kelasID: this.kelasID,
                        category: 'school',
                        show: 'latest',
                    }
                })
                .then(response => {
                    self.latestActivities = response.data
                    self.isLoading5 = false;
                })
                .catch(e => {
                    console.log("666 Error:" + e)
                    self.isLoading5 = false;
                }) 

        },
        isShowRightBorder(index){
            if (index % 2 == 0){
                return 'right-border'
            }
        },
        goStaffAttendance(){            
            this.$router.push({
                name: "StaffAttendanceMain"
            });
        },
        goClassDashboard(){            
            this.$router.push({
                name: "ClassDashboard"
            });
        },
        goSchoolPositiveDetails(){
            this.$router.push({
                name: "SchoolPositiveDetails"
            });
        },
        timeDifference(ts1,ts2){
            //https://stackoverflow.com/questions/16767301/calculate-difference-between-2-timestamps-using-javascript?noredirect=1&lq=1
            var difference = ts1 - ts2;

            //var daysDifference = Math.floor(difference/1000/60/60/24);
            var hoursDifference = Math.floor(difference/1000/60/60);
            //var minutesDifference = Math.floor(difference/1000/60);

            return hoursDifference;
        },
        roundTo2DecimalPlaces(points){  //use lodash to round the points to 2 decimal places
            return _.round(points, 2)
            // return _.round(points, 2).toFixed(2)
        },
        goNewAdmin(){
            this.$router.push({
                name: "Home"
            });
        },
        getMonthDisplay(month){
            month = parseInt(month)
            var monthDisplay = "";
            switch (month){
                case 0:
                    monthDisplay = "January";
                    break;
                case 1:
                    monthDisplay = "February";
                    break;
                case 2:
                    monthDisplay = "March";
                    break;
                case 3:
                    monthDisplay = "April";
                    break;
                case 4:
                    monthDisplay = "May";
                    break;
                case 5:
                    monthDisplay = "June";
                    break;
                case 6:
                    monthDisplay = "July";
                    break;
                case 7:
                    monthDisplay = "August";
                    break;
                case 8:
                    monthDisplay = "September";
                    break;
                case 9:
                    monthDisplay = "October";
                    break;
                case 10:
                    monthDisplay = "November";
                    break;
                case 11:
                    monthDisplay = "December";
                    break;
                default:
                    monthDisplay = "";
                    break;
            }
            return monthDisplay;
        }
    }
};
</script>

<style scoped>
.attendance-pie{
    width: 250px;
    height: 250px;
}
.header-date{
    float: right;
    padding: 10px;
}
.text-center{
    text-align: center;
}
.latest-positive{
    border-top: 1px dotted #ccc;
}
.header-button{
    margin: 5px;
}
.top-border{
    border-top: 1px solid #CCC
}
.right-border{
    border-right: 1px solid #CCC
}
.datepicker{
    margin-left: 30px;
}
</style>
<style module>
.datepicker input{
    border: none; /* <-- This thing here */
    border:1px solid #1849c8;
    border-radius: 5px;
    text-align: center;
    font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue